module.exports = __webpack_public_path__ + "media/images/ogp-2ea948e4acb52b093ea47b5a1a13ccb3.png";